import PropTypes from 'prop-types'
import { Route, Routes } from 'react-router-dom'
import { GenericErrorBoundary } from '../components/2compounds/GenericErrorBoundary'
import ApproveClientClientForm from '../pages/dataImportApproval/approveClient/ApproveClientForm'
import ApproveClientLocationForm from '../pages/dataImportApproval/approveClient/ApproveLocationForm'
import ApproveClientPeopleForm from '../pages/dataImportApproval/approveClient/ApprovePeopleForm'
import ApproveClientServiceForm from '../pages/dataImportApproval/approveClient/ApproveServiceForm'
import ApproveClientServiceSet from '../pages/dataImportApproval/approveClient/ApproveServiceSet'
import ApproveLocationClientForm from '../pages/dataImportApproval/approveLocation/ApproveClientForm'
import ApproveLocationLocationForm from '../pages/dataImportApproval/approveLocation/ApproveLocationForm'
import ApproveLocationPeopleForm from '../pages/dataImportApproval/approveLocation/ApprovePeopleForm'
import ApproveLocationServiceForm from '../pages/dataImportApproval/approveLocation/ApproveServiceForm'
import ApprovePeopleLocationForm from '../pages/dataImportApproval/approvePeople/ApproveLocationForm'
import ApprovePeoplePeopleForm from '../pages/dataImportApproval/approvePeople/ApprovePeopleForm'
import ApproveServiceClientForm from '../pages/dataImportApproval/approveService/ApproveClientForm'
import ApproveServiceLocationForm from '../pages/dataImportApproval/approveService/ApproveLocationForm'
import ApproveServiceNewServiceForm from '../pages/dataImportApproval/approveService/ApproveNewServiceForm'
import ApproveServiceServiceForm from '../pages/dataImportApproval/approveService/ApproveServiceForm'

const routesByFlow = {
  approveClient: [
    { path: 'client/:id', Component: ApproveClientClientForm },
    { path: 'serviceSet/:id', Component: ApproveClientServiceSet },
    { path: 'location/:id', Component: ApproveClientLocationForm },
    { path: 'people/:id', Component: ApproveClientPeopleForm },
    { path: 'service/:id', Component: ApproveClientServiceForm },
  ],
  approveLocation: [
    { path: 'client/:id', Component: ApproveLocationClientForm },
    { path: 'location/:id', Component: ApproveLocationLocationForm },
    { path: 'people/:id', Component: ApproveLocationPeopleForm },
    { path: 'service/:id', Component: ApproveLocationServiceForm },
  ],
  approvePeople: [
    { path: 'location/:id', Component: ApprovePeopleLocationForm },
    { path: 'people/:id', Component: ApprovePeoplePeopleForm },
  ],
  approveService: [
    { path: 'location/:id', Component: ApproveServiceLocationForm },
    { path: 'service/:id', Component: ApproveServiceServiceForm },
    { path: 'client/:id', Component: ApproveServiceClientForm },
    { path: 'newService/:id', Component: ApproveServiceNewServiceForm },
  ],
}

const ApprovalWorkflowRoutes = ({ flow }) => (
  <Routes>
    {routesByFlow[flow].map(({ path, Component }) => (
      <Route
        key={path}
        path={path}
        element={(
          <GenericErrorBoundary>
            <Component />
          </GenericErrorBoundary>
        )}
      />
    ))}
  </Routes>
)

ApprovalWorkflowRoutes.propTypes = {
  flow: PropTypes.oneOf(Object.keys(routesByFlow)).isRequired,
}

export default ApprovalWorkflowRoutes
